import { render, staticRenderFns } from "./data61.vue?vue&type=template&id=7064a4ab&scoped=true"
import script from "./data61.vue?vue&type=script&lang=js"
export * from "./data61.vue?vue&type=script&lang=js"
import style1 from "./data61.vue?vue&type=style&index=1&id=7064a4ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064a4ab",
  null
  
)

export default component.exports